import { render, staticRenderFns } from "./TramoRutaDetalle.vue?vue&type=template&id=4e18493e"
import script from "./TramoRutaDetalle.vue?vue&type=script&lang=js"
export * from "./TramoRutaDetalle.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports